// Textos únicos das "dicas" (tooltips) espalhadas pelo app.
// Ver PEDIDO_EMERGENT_REGISTRAR_CONTATO_E_VISITA — Parte 2.
// Manter aqui centralizado para revisão simples.

export const DICAS = {
  // Ficha do cliente — barra de ações
  clienteVisita: "Anote uma visita que você já fez. Conta como contato com o cliente.",
  clienteContato: "Anote uma ligação, WhatsApp ou e-mail que você já fez. Zera os dias sem contato.",
  clienteAgendar: "Marque o próximo passo com este cliente. Vai para a sua Agenda.",
  clienteOportunidade: "Abra uma negociação deste cliente no funil.",
  clienteCustoUso: "Monte a análise de custo por uso e gere a proposta em PDF.",
  clientePedirRetorno: "Registre uma solicitação ao vendedor e avise pelo WhatsApp.",

  // Início (Dashboard)
  homeQuadroMeta: "Seu faturamento no Sankhya comparado à meta do mês.",
  homeVendasDiretas: "Suas vendas como vendedor. Já estão somadas no total da equipe.",
  homeRequerAtencao: "Clientes e tarefas que precisam de ação agora.",

  // Painel de Faturamento
  fatMarcadorMeta: "Onde você deveria estar hoje para bater a meta no fim do mês.",
  fatProjecao: "Quanto fecha o mês se o ritmo de vendas continuar igual.",
  fatFaltaMeta: "Quanto ainda falta vender, e quanto isso dá por dia útil.",
  fatClientesFaturados: "Clientes com nota no período. \u201CNovos\u201D = sem compra nos 12 meses anteriores.",
  fatTicketMedio: "Valor médio de cada nota de venda no período.",
  fatMaioresClientes: "Quem mais comprou no período. Toque para abrir a ficha.",

  // Equipe
  equipeFaturadoSankhya: "Soma das vendas da equipe no Sankhya, incluindo as suas.",
  equipeAtingimento: "Faturado dividido pela meta do mês.",
};
